export interface DistributionRow {
  label: string
  count: number
  /** A CSS colour for the bar. The label and count carry the meaning; the colour only echoes it. */
  color: string
}

/**
 * How a whole splits into a few named parts — words by status, reviews by rating.
 * One labelled row per part, so every value is written out and colour never
 * carries the meaning alone.
 */
export function DistributionBars({ label, rows }: { label: string; rows: DistributionRow[] }) {
  const total = rows.reduce((sum, row) => sum + row.count, 0)

  return (
    <ul aria-label={label} className="flex flex-col gap-3">
      {rows.map((row) => {
        const share = total ? row.count / total : 0
        return (
          <li key={row.label} className="grid grid-cols-[6.5rem_minmax(0,1fr)_auto] items-center gap-3 sm:gap-4">
            <span className="font-serif text-sm text-body">{row.label}</span>
            <span aria-hidden="true" className="h-2 overflow-hidden rounded-full bg-muted/15">
              <span
                className="block h-full rounded-full"
                style={{ width: `${share * 100}%`, minWidth: row.count ? '4px' : 0, backgroundColor: row.color }}
              />
            </span>
            <span className="text-right font-mono text-xs tabular-nums text-muted">
              <span className="text-heading">{row.count.toLocaleString()}</span>
              <span className="ml-2 inline-block w-9">{Math.round(share * 100)}%</span>
            </span>
          </li>
        )
      })}
    </ul>
  )
}
